// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1Pvtj","avatar":"style_avatar__b7mIv"};